import Breadcrumbs from '@/components/Breadcrumbs';
import { fadeIn } from '@/constants/motions';
import { motion } from 'framer-motion';

export default function BreadcrumbsBlock({ items, ...props }) {
  return (
    <motion.section
      className="my-8 px-4"
      initial="hidden"
      transition={fadeIn.transition}
      variants={fadeIn}
      viewport={fadeIn.viewport}
      whileInView="visible"
      {...props}
    >
      <div className="container-screen">
        <Breadcrumbs items={items} />
      </div>
    </motion.section>
  );
}
